import { useState, useEffect } from 'react';

import './Widget.css';

function CopyButton(props) {
  const [visibility, setVisibility] = useState('hide');
  const [position, setPosition] = useState('bottom-right');

  useEffect(() => {
    props.position && setPosition(props.position);
  }, []);

  function handleClick() {
    // console.log(props?.data);
    navigator.clipboard.writeText(props.data);    
    setVisibility('show');
    setTimeout(() => setVisibility('hide'), 300);
  }

  return (
    <div>       
      <div className={visibility}>
        <div className={'btn-popover ' + position}>
          <span className="popover-text">Copied!</span>
        </div>
      </div>
      <button type="button" title="Copy" 
        className={"btn btn-primary btn-sm regular-text " + position}
        onClick={handleClick}>
          <i className="fa fa-clipboard" aria-hidden="true"></i>
          {/* <div>Copy</div> */}
      </button>
    </div>
  )

}

export default CopyButton;